import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SidebarButtonModule } from './components/buttons/ls-sidebar-button/sidebar-button.module';
import { InfoSettingTooltipComponent } from './form/components/info-setting-tooltip.component';
import { AlwaysShowRouteResolver } from './navigation/always-show-route-resolver';
import { NeverShowRouteResolver } from './navigation/never-show-route-resolver';
import { DecimalCompanyPipe } from './pipes/decimal.pipe';
import { CookieOptionsProvider } from 'ngx-cookie';
import { DynamicTranslationModule } from './dynamic-translation/dynamic-translation.module';
import { AccountFacade } from '../account/store/facades/account-facade';

@NgModule({
  imports: [CommonModule, DynamicTranslationModule],
  declarations: [DecimalCompanyPipe, InfoSettingTooltipComponent],
  exports: [
    SidebarButtonModule,
    DecimalCompanyPipe,
    InfoSettingTooltipComponent
  ],
  providers: [
    NeverShowRouteResolver,
    AlwaysShowRouteResolver,
    AccountFacade,
    {
      provide: CookieOptionsProvider,
      useValue: { path: '/' }
    }
  ]
})
export class SharedModule {}
